import type {SVGProps} from 'react';
import * as React from 'react';
export const PersonIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="M.75 17.23a6.75 6.75 0 0 1 9.4-6.21m2.1 7.53 1.66 1.67 3.34-3.34M3.37 4.85a4.13 4.13 0 1 0 8.26 0 4.13 4.13 0 0 0-8.26 0Zm7.41 18.37a4.54 4.54 0 0 1 0-9.07h7.93a4.54 4.54 0 1 1 0 9.07h-7.93Z"
		/>
	</svg>
);
